<template>
    <div>
        <div>
            <p>
                V nejbližší době vás budeme kontaktovat ohledně nabídky a
                nastavení vašich služeb. vyberte způsob úhrady a pak pokračujte
                do servisní sekce, kde můžete dokončit nastavení vaší firmy.
            </p>

            <div class="custom-control custom-radio">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <input
                            id="proformaRadio"
                            v-model="payment_method"
                            type="radio"
                            class="custom-control-input"
                            name="paytype"
                            value="1"
                        />
                        <label class="custom-control-label" for="proformaRadio">
                            <span class="price">
                                <b>{{ price }} Kč</b>
                            </span>
                            <div class="price_with_tax">
                                s DPH {{ priceWithTax }},-
                            </div>
                        </label>
                    </div>
                    <div class="col-12 col-sm-6 pb-5">
                        Chci poslat proforma fakturu
                    </div>
                </div>
            </div>

            <div class="custom-control custom-radio">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <input
                            id="gopayRadio"
                            v-model="payment_method"
                            type="radio"
                            class="custom-control-input"
                            name="paytype"
                            value="3"
                        />
                        <label class="custom-control-label" for="gopayRadio">
                            <span class="price">
                                <b>{{ priceDiscounted }} Kč</b>
                                <template v-if='discount > 0'>(sleva {{ discount }} Kč)</template>
                            </span>
                            <div class="price_with_tax">
                                s DPH {{ priceDiscountedWithTax }},-
                            </div>
                        </label>
                    </div>
                    <div class="col-12 col-sm-6">
                        Zaplatit kartou nebo on-line převodem
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row mt-5">
                    <button class="button-02" @click="setOrder()">
                        Pokračovat
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            payment_method: 3,
            discount: Number.parseInt(this.$store.state.config.discount),
            tax: Number.parseInt(this.$store.state.config.tax),
        }
    },
    computed: {
        id_firmy() {
            return this.$store.state.firm.result.id_firmy
        },
        opravny_kod() {
            return this.$store.state.firm.result.opravny_kod
        },
        price() {
            const standard_presentation = this.$store.state.presentations.presentations.find(
                element => element.id == 2
            )
            return Number.parseInt(standard_presentation.price_per_year)
        },
        priceDiscounted() {
            // return this.price - (this.price * this.discount) / 100
            return (this.price - this.discount)
        },
        priceWithTax() {
            return this.price * ((100 + this.tax) / 100)
        },
        priceDiscountedWithTax() {
            return this.priceDiscounted * ((100 + this.tax) / 100)
        },
        firm() {
            return this.$store.state.firm
        },
    },
    methods: {
        setOrder() {
            // ulozi zpusob platby
            this.$store.commit('firm/setOrderOptions', {
                payment_method: this.payment_method,
            })
            this.$store.dispatch(
                'loader/setLoader',
                'Vytvářím objednávku služeb ...'
            )
            const vm = this
            // vytvori objednavku

            let price
            if (this.payment_method == 3) {
                price = this.priceDiscountedWithTax
            } else {
                price = this.priceWithTax
            }
            this.$store
                .dispatch('order/updateOrder', price)
                .then(order_number => {
                    console.log(`Objednávka ${order_number} vytvořena.`)
                    this.$store.dispatch(
                        'loader/setLoader',
                        `Objednávka ${order_number} vytvořena.`
                    )
                    /*
                    const pb_url = `https://platba.ci.cz/payment/firm/?fid=${this.id_firmy}&opravny_kod=${this.opravny_kod}&order_number=${this.order_number}&callback=${window.location.href}`;

                    setTimeout(() => {
                            window.location.href = pb_url;
                    },
                        3000
                    );
                    */
                    if (vm.payment_method == 3) {
                        console.log(
                            'vybrana platba kartou, zobrazim platebni branu'
                        )
                        this.$store.commit('step/setStep', 'gopay')
                    } else {
                        console.log('vybrana proforma faktura')
                        this.$store.dispatch('loader/setLoader', '')
                        this.$store.commit('step/setStep', 'nopay')
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$store.dispatch('loader/setError', error)
                })
        },
    },
}
</script>
